<template>
    <div>
        <form @submit.prevent="changePassword" class="md-layout">
            <md-field>
                <label>{{ $t("message.password") }}</label>
                <md-input
                    v-model="resetPasswordFields.newPassword"
                    v-validate="'required|min:6'"
                    type="password"
                    :name="$t('message.newPassword')"
                    ref="password"
                />
            </md-field>
            <md-field>
                <label>{{ $t("message.passwordRepeat") }}</label>
                <md-input
                    v-validate="'required|confirmed:password'"
                    :name="$t('message.passwordRepeat')"
                    type="password"
                    v-model="resetPasswordFields.newPasswordRepeat"
                />
            </md-field>

            <md-button class="md-primary" type="submit" :disabled="loading">
                <md-progress-spinner
                    :md-diameter="20"
                    v-if="loading"
                    class="md-accent"
                    md-mode="indeterminate"
                ></md-progress-spinner>
                <span v-else>{{ $t("message.changePassword") }}</span>
            </md-button>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "ResetPassword",
    data() {
        return {
            resetPasswordFields: {
                newPassword: "",
                newPasswordRepeat: "",
            },
            loading: false,
        };
    },
    props: {
        onCompleted: Function,
        default: () => {},
    },
    methods: {
        ...mapActions({
            resetPassword: "auth/resetPassword",
        }),
        changePassword() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    const payload = {
                        password: this.resetPasswordFields.newPassword,
                        token: this.$route.query.ptoken,
                        isPasswordless: true,
                    };
                    this.resetPassword(payload)
                        .then((res) => {
                            this.onCompleted();
                            this.$router.push("/");
                        })
                        .catch((err) => {
                            const errMsg =
                                err.response && err.response.data && err.response.data.localizedMessages
                                    ? err.response.data.localizedMessages[this.$i18n.locale]
                                    : err.message;
                            this.$bvToast.toast(errMsg, {
                                title: this.$t("message.error"),
                                variant: "danger",
                                solid: true,
                            });
                        })
                        .finally(() => (this.loading = false));
                }
            });
        },
    },
};
</script>

<style scoped></style>
